import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Container,
  VStack,
  HStack,
  Image,
  Text,
  IconButton,
  useColorMode,
  Input,
  InputGroup,
  InputLeftElement,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FiSearch, FiPlay, FiHeart, FiMoreVertical } from "react-icons/fi";
import { useMusic } from "../context/MusicContext";
import axios from "axios";
import AudioVisualizer from "../components/AudioVisualizer";
import Cookies from "js-cookie";
import { PiHeartStraightFill } from "react-icons/pi";
const MotionBox = motion(Box);


const Search = () => {
  const { colorMode } = useColorMode();
  const [searchQuery, setSearchQuery] = useState("");
  const hasReachedBottom = useRef(false);
  // Mock data for search results
  const [searchResult, setSearchResult] = useState([]);
  const User = useRef(JSON.parse(Cookies.get("User")));
  let PageIndex = 1;

  const [isloading, setIsloading] = useState(false);

  const {
    setCurrentList,
    audioRef,
    currentTime,
    currentTrack,
    setCurrentTrack,
    setIsPlaying,
  } = useMusic();

  useEffect(() => {
    const value = localStorage.getItem("Search");
    if (value) {
      // فقط برای ست شدن در UI
      setSearchQuery(value); // پاک‌کردن نتایج قبلی
      // جستجو با مقدار مستقیم از localStorage
    }
  }, []);

  useEffect(() => {
    if (searchQuery.trim()) {
      setTimeout(() => {
        setSearchResult([]); // پاک کردن قبلی
        Search(searchQuery);
        localStorage.setItem("Search", searchQuery); // جستجو جدید
      }, 1000);
    } else {
      setSearchResult([]);
    }
  }, [searchQuery]);

  useEffect(() => {
    if (!searchQuery) {
      setSearchResult([]);
    }
  }, [searchResult]);

  function Search(query) {
    setIsloading(true);
    axios
      .get(
        `https://apiArmanify.zx-tm.ir/api/songs/scrape?url=https://musics-fa.com/search/${query}?page=1`
      )
      .then((response) => {
        console.log(response.data);
        setSearchResult(response.data);
        setCurrentList(response.data);

        setIsloading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsloading(false);
      });
  }

  function play(url) {
    axios
      .get(`https://apiArmanify.zx-tm.ir/api/songs/music?url=${url}`)
      .then((response) => {
        setCurrentTrack({
          page_url: url,
          title: response.data.title,
          artist: response.data.title,
          cover: response.data.coverUrl,
          url: response.data.mp3Url,
          duration: 0,
        });
        setIsPlaying(true);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function Add_FAV(page_url, url) {
    axios
      .post(
        `https://apiArmanify.zx-tm.ir/api/FevSongs/create?songId=${page_url}&songUrl=${url}&userId=${User.current.userId}`
      )
      .then((res) => {
        alert("آهنگ به علاقه مندی ها اضافه شد");
      })
      .catch((err) => {
        alert("خطا در اضافه کردن به علاقه مندی");
      });
  }

  const handleScroll = (e) => {
    const el = e.target;

    const isAtBottom =
      Math.abs(el.scrollHeight - el.scrollTop - el.clientHeight) < 1;

    if (isAtBottom && !hasReachedBottom.current) {
      console.log("✅ فقط یک بار پیام: رسید به انتها");
      hasReachedBottom.current = true;
    }
  };

  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        <InputGroup size="lg">
          <InputLeftElement>
            <IconButton
              onClick={() => setSearchResult([])}
              icon={<FiSearch />}
              colorScheme="brand"
              size="sm"
              aria-label="Play"
            />
          </InputLeftElement>
          <Input
            placeholder="جستجوی آهنگ، هنرمند ..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            bg={colorMode === "dark" ? "gray.700" : "white"}
            borderRadius="full"
          />
        </InputGroup>

        <Tabs variant="soft-rounded" colorScheme="brand">
          {/* <TabList>
            <Tab>آهنگ‌ها</Tab>
            <Tab>هنرمندها</Tab>
            <Tab>پلی‌لیست‌ها</Tab>
          </TabList> */}

          <TabPanels>
            <TabPanel
              onScroll={handleScroll}
              style={{
                height: "71vh",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              <VStack spacing={4} align="stretch">
                {searchResult.map((song, index) => (
                  <MotionBox
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                  >
                    <HStack
                      p={4}
                      bg={colorMode === "dark" ? "gray.700" : "white"}
                      borderRadius="lg"
                      spacing={4}
                      _hover={{
                        bg: colorMode === "dark" ? "gray.600" : "gray.50",
                      }}
                      cursor="pointer"
                    >
                      <Image
                        src={song.cover}
                        alt={song.artist}
                        boxSize="50px"
                        borderRadius="md"
                      />
                      <Box flex="1">
                        <Text
                          fontSize="small"
                          color={colorMode === "dark" ? "whitesmoke" : "black"}
                        >
                          {song.artist}
                        </Text>
                        {/* <Text fontSize="sm" color="gray.500">
                          {song.artist}
                        </Text> */}
                      </Box>
                      <HStack spacing={2}>
                        <IconButton
                          icon={<PiHeartStraightFill />}
                          variant="ghost"
                          colorScheme="red"
                          aria-label="Remove from favorites"
                          onClick={() =>
                            Add_FAV(
                              `https://musics-fa.com/download-song/${song.id}`,
                              song.songUrl
                            )
                          }
                        />
                        <IconButton
                          onClick={() =>
                            play(
                              `https://musics-fa.com/download-song/${song.id}`
                            )
                          }
                          icon={
                            currentTrack.url ===
                            `https://musics-fa.com/download-song/${song.id}` ? (
                              <AudioVisualizer />
                            ) : (
                              <FiPlay />
                            )
                          }
                          variant="ghost"
                          colorScheme="brand"
                          aria-label="Play"
                        />
                      </HStack>
                    </HStack>
                  </MotionBox>
                ))}
                <span
                  className="loader"
                  style={{ display: isloading ? "block" : "none" }}
                ></span>
              </VStack>
            </TabPanel>

            {/* <TabPanel>
              <VStack spacing={4} align="stretch">
                {searchResults.artists.map((artist, index) => (
                  <MotionBox
                    key={artist.id}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                  >
                    <HStack
                      p={4}
                      bg={colorMode === 'dark' ? 'gray.700' : 'white'}
                      borderRadius="lg"
                      spacing={4}
                      _hover={{ bg: colorMode === 'dark' ? 'gray.600' : 'gray.50' }}
                      cursor="pointer"
                    >
                      <Image
                        src={artist.image}
                        alt={artist.name}
                        boxSize="60px"
                        borderRadius="full"
                      />
                      <Box flex="1">
                        <Text fontWeight="bold" fontSize="lg">
                          {artist.name}
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                          {artist.followers} دنبال‌کننده
                        </Text>
                      </Box>
                      <IconButton
                        icon={<FiMoreVertical />}
                        variant="ghost"
                        aria-label="More options"
                      />
                    </HStack>
                  </MotionBox>
                ))}
              </VStack>
            </TabPanel>

            <TabPanel>
              <VStack spacing={4} align="stretch">
                {searchResults.playlists.map((playlist, index) => (
                  <MotionBox
                    key={playlist.id}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                  >
                    <HStack
                      p={4}
                      bg={colorMode === 'dark' ? 'gray.700' : 'white'}
                      borderRadius="lg"
                      spacing={4}
                      _hover={{ bg: colorMode === 'dark' ? 'gray.600' : 'gray.50' }}
                      cursor="pointer"
                    >
                      <Image
                        src={playlist.cover}
                        alt={playlist.name}
                        boxSize="60px"
                        borderRadius="md"
                      />
                      <Box flex="1">
                        <Text fontWeight="bold" fontSize="lg">
                          {playlist.name}
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                          {playlist.creator} • {playlist.songCount} آهنگ
                        </Text>
                      </Box>
                      <HStack spacing={2}>
                        <IconButton
                          icon={<FiPlay />}
                          variant="ghost"
                          colorScheme="brand"
                          aria-label="Play playlist"
                        />
                        <IconButton
                          icon={<FiMoreVertical />}
                          variant="ghost"
                          aria-label="More options"
                        />
                      </HStack>
                    </HStack>
                  </MotionBox>
                ))}
              </VStack>
            </TabPanel> */}
          </TabPanels>
        </Tabs>
      </VStack>
    </Container>
  );
};

export default Search;
